import { z } from "zod";
import { apiOssProxyInternal } from "./api";
import { EhrName } from "@metriport/shared-internal";
import { CxMapping, cxMappingSchema, PatientMapping, patientMappingSchema } from "./schemas/ehr";

export type { CxMapping, PatientMapping };

export async function getCxMappingsByCxId(cxId: string, source?: string): Promise<CxMapping[]> {
  const resp = await apiOssProxyInternal.get(
    `/${encodeURIComponent(cxId)}/cx-mapping`,
    source ? { params: { source } } : undefined
  );
  if (!resp.data) return [];
  return z.array(cxMappingSchema).parse(resp.data);
}

export async function getPatientMapping({
  ehrId,
  externalId,
}: {
  ehrId: string;
  externalId: string;
}): Promise<PatientMapping> {
  const resp = await apiOssProxyInternal.get(
    `/ehr/${encodeURIComponent(ehrId)}/patient/${encodeURIComponent(externalId)}/mapping`
  );
  if (!resp.data) throw new Error("Patient mapping not returned");
  return patientMappingSchema.parse(resp.data);
}

export async function linkPatient({
  cxId,
  patientId,
  practiceId,
  ehr,
}: {
  cxId: string;
  patientId: string;
  practiceId: string;
  ehr: EhrName;
}): Promise<void> {
  if (ehr !== EhrName.Healthie && ehr !== EhrName.Elation) {
    throw new Error(`Ehr: ${ehr} does not support linking`);
  }
  await apiOssProxyInternal.post(`/ehr/${ehr.toLowerCase()}/patient/link`, null, {
    params: { cxId, patientId, practiceId },
  });
}
